"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3661],{

/***/ 32451:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_MapInt = __webpack_require__(91094);
var Util$SmartcutsMacros = __webpack_require__(25092);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var LoopCommand$SmartcutsMacros = __webpack_require__(67259);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var TypeCommand$SmartcutsMacros = __webpack_require__(92095);
var ClickCommand$SmartcutsMacros = __webpack_require__(658);
var RadioCommand$SmartcutsMacros = __webpack_require__(84259);
var SelectCommand$SmartcutsMacros = __webpack_require__(16997);
var UploadCommand$SmartcutsMacros = __webpack_require__(68210);
var CheckboxCommand$SmartcutsMacros = __webpack_require__(50108);
var DownloadCommand$SmartcutsMacros = __webpack_require__(59170);
var URLRelatedCommands$SmartcutsMacros = __webpack_require__(9697);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
function t_encode(v) {
    switch(v.TAG | 0){
        case /* AddTextInputParamValue */ 0:
            return [
                "AddTextInputParamValue",
                Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.t_encode, v._0)
            ];
        case /* InnerTextParamValue */ 1:
            return [
                "InnerTextParamValue",
                Curry._1(ClickCommand$SmartcutsMacros.PlaybackParamValue.t_encode, v._0)
            ];
        case /* CheckboxParamValue */ 2:
            return [
                "CheckboxParamValue",
                CheckboxCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
        case /* SelectInputParamValue */ 3:
            return [
                "SelectInputParamValue",
                SelectCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
        case /* RadioInputParamValue */ 4:
            return [
                "RadioInputParamValue",
                RadioCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
        case /* URLParamValue */ 5:
            return [
                "URLParamValue",
                URLRelatedCommands$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
        case /* DownloadParamValue */ 6:
            return [
                "DownloadParamValue",
                DownloadCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
        case /* GoogleSheetsParamValue */ 7:
            return [
                "GoogleSheetsParamValue",
                GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
        case /* LoopParamValue */ 8:
            return [
                "LoopParamValue",
                LoopCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
        case /* UploadParamValue */ 9:
            return [
                "UploadParamValue",
                UploadCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
        case /* WithElementGroupsParamValue */ 10:
            return [
                "WithElementGroupsParamValue",
                WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.t_encode(v._0)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AddTextInputParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AddTextInputParamValue */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CheckboxParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = CheckboxCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CheckboxParamValue */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "DownloadParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = DownloadCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DownloadParamValue */ 6,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "GoogleSheetsParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GoogleSheetsParamValue */ 7,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "InnerTextParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Curry._1(ClickCommand$SmartcutsMacros.PlaybackParamValue.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InnerTextParamValue */ 1,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "LoopParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = LoopCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LoopParamValue */ 8,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "RadioInputParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = RadioCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RadioInputParamValue */ 4,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "SelectInputParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = SelectCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectInputParamValue */ 3,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "URLParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = URLRelatedCommands$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* URLParamValue */ 5,
                            _0: v0$8._0
                        }
                    };
                }
                var e$8 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "UploadParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = UploadCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UploadParamValue */ 9,
                            _0: v0$9._0
                        }
                    };
                }
                var e$9 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "WithElementGroupsParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WithElementGroupsParamValue */ 10,
                            _0: v0$10._0
                        }
                    };
                }
                var e$10 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$1(v) {
    return [
        "UpdateWithElementGroupsParamValue",
        Curry._1(WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.Update.t_encode, v._0)
    ];
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "UpdateWithElementGroupsParamValue") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Curry._1(WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.Update.t_decode, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* UpdateWithElementGroupsParamValue */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(update) {
    return "UpdateWithElementGroupsParamValue(v)";
}
function apply(value, update) {
    if (value.TAG !== /* WithElementGroupsParamValue */ 10) {
        return value;
    }
    var func = WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.Update.apply;
    return {
        TAG: /* WithElementGroupsParamValue */ 10,
        _0: Curry._2(func, value._0, update._0)
    };
}
function substituteIntoCommand(command, update) {
    if (typeof command === "number") {
        return command;
    }
    if (command.TAG !== /* WithElementGroupsCommand */ 43) {
        return command;
    }
    var cmdVal = command._0;
    return {
        TAG: /* WithElementGroupsCommand */ 43,
        _0: {
            sequence: cmdVal.sequence,
            iteratorStrategy: cmdVal.iteratorStrategy,
            paginateOptions: cmdVal.paginateOptions,
            transducers: cmdVal.transducers,
            actions: Belt_Array.reduce(Belt_MapInt.toArray(update._0.actions), cmdVal.actions, function(actions, param) {
                var index = param[0];
                var match = Belt_Array.get(actions, index);
                if (match === undefined) {
                    return actions;
                }
                var exportTo = match._0;
                return ArrayUtils$SmartcutsMacros.replaceAtIndex(actions, index, /* ExportTo */ {
                    _0: {
                        destination: {
                            TAG: /* NewGoogleSheet */ 1,
                            _0: {
                                TAG: /* Resolved */ 0,
                                _0: param[1]._0._0
                            }
                        },
                        columns: exportTo.columns,
                        maybeExtraColumns: exportTo.maybeExtraColumns,
                        maybePrimayKeys: exportTo.maybePrimayKeys,
                        snapshotOfDataExported: exportTo.snapshotOfDataExported
                    }
                });
            })
        }
    };
}
var Update = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify,
    apply: apply,
    substituteIntoCommand: substituteIntoCommand
};
function stringify$1(v) {
    switch(v.TAG | 0){
        case /* AddTextInputParamValue */ 0:
            return "AddTextInputParamValue(" + (Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.stringify, v._0) + ")");
        case /* InnerTextParamValue */ 1:
            return "InnerTextParamValue(" + (v._0 + ")");
        case /* CheckboxParamValue */ 2:
            return "CheckboxParamValue(" + (CheckboxCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
        case /* SelectInputParamValue */ 3:
            return "SelectInputParamValue(" + (SelectCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
        case /* RadioInputParamValue */ 4:
            return "RadioInputParamValue(" + (RadioCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
        case /* URLParamValue */ 5:
            return "URLParamValue(" + (URLRelatedCommands$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
        case /* DownloadParamValue */ 6:
            return "DownloadParamValue(" + (DownloadCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
        case /* GoogleSheetsParamValue */ 7:
            return "GoogleSheetsParamValue(" + (GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
        case /* LoopParamValue */ 8:
            return "LoopParamValue(" + LoopCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0);
        case /* UploadParamValue */ 9:
            return "UploadParamValue(" + UploadCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0);
        case /* WithElementGroupsParamValue */ 10:
            return "WithElementGroupsParamValue(" + (WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.stringify(v._0) + ")");
    }
}
function minify(x) {
    return x;
}
function fromSmartcutParam(param) {
    switch(param.TAG | 0){
        case /* AddTextInputParam */ 0:
            return {
                TAG: /* AddTextInputParamValue */ 0,
                _0: Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.fromParamDescriptor, param._0)
            };
        case /* InnerTextParam */ 1:
            return {
                TAG: /* InnerTextParamValue */ 1,
                _0: Curry._1(ClickCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor, param._0)
            };
        case /* CheckboxParam */ 2:
            return {
                TAG: /* CheckboxParamValue */ 2,
                _0: CheckboxCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
        case /* SelectInputParam */ 3:
            return {
                TAG: /* SelectInputParamValue */ 3,
                _0: SelectCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
        case /* RadioInputParam */ 4:
            return {
                TAG: /* RadioInputParamValue */ 4,
                _0: RadioCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
        case /* URLParam */ 5:
            return {
                TAG: /* URLParamValue */ 5,
                _0: URLRelatedCommands$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
        case /* DownloadParam */ 6:
            return {
                TAG: /* DownloadParamValue */ 6,
                _0: DownloadCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
        case /* GoogleSheetsParam */ 7:
            return {
                TAG: /* GoogleSheetsParamValue */ 7,
                _0: GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
        case /* LoopParam */ 8:
            return {
                TAG: /* LoopParamValue */ 8,
                _0: LoopCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
        case /* UploadParam */ 9:
            return {
                TAG: /* UploadParamValue */ 9,
                _0: UploadCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
        case /* WithElementGroupsParam */ 10:
            return {
                TAG: /* WithElementGroupsParamValue */ 10,
                _0: WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(param._0)
            };
    }
}
function t__encode(v) {
    return CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(t_encode, v);
}
function t__decode(v) {
    return CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(t_decode, v);
}
function commandIndexAndValueTuples_encode(v) {
    return Decco.arrayToJson(function(param) {
        return [
            Decco.intToJson(param[0]),
            t_encode(param[1])
        ];
    }, v);
}
function commandIndexAndValueTuples_decode(v) {
    return Decco.arrayFromJson(function(json) {
        var match = Js_json.classify(json);
        if (typeof match === "number") {
            return Decco.error(undefined, "Not a tuple", json);
        }
        if (match.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a tuple", json);
        }
        var match$1 = match._0;
        if (match$1.length !== 2) {
            return Decco.error(undefined, "Incorrect cardinality", json);
        }
        var v0 = match$1[0];
        var v1 = match$1[1];
        var match$2 = Decco.intFromJson(v0);
        var match$3 = t_decode(v1);
        if (match$2.TAG === /* Ok */ 0) {
            if (match$3.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: [
                        match$2._0,
                        match$3._0
                    ]
                };
            }
            var e = match$3._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$2._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }, v);
}
function minify$1(map) {
    return Belt_MapInt.map(map, minify);
}
function fromSmartcutParams(smartcutParams) {
    return Belt_Array.reduce(smartcutParams, undefined, function(smartcutParamValuesByCommandIndex, paramDescriptor) {
        return Belt_MapInt.set(smartcutParamValuesByCommandIndex, paramDescriptor.firstCommandIndex, fromSmartcutParam(paramDescriptor.param));
    });
}
function fromSmartcutParamsWithMaybeFirstUrl(maybeFirstUrl, smartcutParams) {
    return Belt_Array.reduceWithIndex(smartcutParams, undefined, function(pvaluesByCommandIndex, paramDescriptor, index) {
        var param = paramDescriptor.param;
        if (param.TAG === /* URLParam */ 5 && index === 0) {
            var match = param._0;
            return Belt_MapInt.set(pvaluesByCommandIndex, 0, {
                TAG: /* URLParamValue */ 5,
                _0: {
                    url: OptionUtils$SmartcutsMacros.withDefault(match.originalUrl, maybeFirstUrl),
                    urlCommandType: match.urlCommandType
                }
            });
        }
        if (index === 0) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected first param to be a url param");
        }
        var pvaluesByCommandIndex_1 = Belt_MapInt.set(pvaluesByCommandIndex, paramDescriptor.firstCommandIndex, fromSmartcutParam(param));
        return Belt_List.reduce(paramDescriptor.otherCommandIndexes, pvaluesByCommandIndex_1, function(pvaluesByCommandIndex_2, otherCommandIndex) {
            return Belt_MapInt.set(pvaluesByCommandIndex_2, otherCommandIndex, fromSmartcutParam(param));
        });
    });
}
function preserveObjectUrlInPlaybackData(map) {
    return Promise.all(Belt_Array.map(Belt_MapInt.toArray(map), function(param) {
        var playbackParamValue = param[1];
        var commandIndex = param[0];
        if (playbackParamValue.TAG !== /* UploadParamValue */ 9) {
            return Promise.resolve([
                commandIndex,
                playbackParamValue
            ]);
        }
        var match = playbackParamValue._0;
        if (match.TAG !== /* FileObject */ 0) {
            return Promise.resolve([
                commandIndex,
                playbackParamValue
            ]);
        }
        var match$1 = match._0;
        var fileName = match$1.fileName;
        return fetch(match$1.objectUrl).then(function(prim) {
            return prim.blob();
        }).then(function(blob) {
            var objectUrl$p = URL.createObjectURL(blob);
            return Promise.resolve([
                commandIndex,
                {
                    TAG: /* UploadParamValue */ 9,
                    _0: {
                        TAG: /* FileObject */ 0,
                        _0: {
                            objectUrl: objectUrl$p,
                            fileName: fileName
                        }
                    }
                }
            ]);
        });
    })).then(function(results) {
        return Promise.resolve(Belt_MapInt.fromArray(results));
    });
}
var ValuesByCommandIndex = {
    t__encode: t__encode,
    t__decode: t__decode,
    commandIndexAndValueTuples_encode: commandIndexAndValueTuples_encode,
    commandIndexAndValueTuples_decode: commandIndexAndValueTuples_decode,
    minify: minify$1,
    fromSmartcutParams: fromSmartcutParams,
    fromSmartcutParamsWithMaybeFirstUrl: fromSmartcutParamsWithMaybeFirstUrl,
    preserveObjectUrlInPlaybackData: preserveObjectUrlInPlaybackData
};
function substitutePlaybackValuesIntoCommandLog(commandLog1, playbackValuesByCommandIndex) {
    return Belt_MapInt.reduce(playbackValuesByCommandIndex, commandLog1, function(commandLog, commandIndex, playbackParamValue) {
        var commandLog_2 = ListUtils$SmartcutsMacros.updateAt(commandIndex, function(cmdWithContext) {
            var contextGlobal = cmdWithContext.contextGlobal;
            var command = cmdWithContext.command;
            switch(playbackParamValue.TAG | 0){
                case /* AddTextInputParamValue */ 0:
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* TypeCommand */ 15,
                            _0: Curry._1(TypeCommand$SmartcutsMacros.PlaybackParamValue.AddTextInputParam.toCommandValueForPlayback, playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* InnerTextParamValue */ 1:
                    var tmp;
                    tmp = typeof command === "number" || command.TAG !== /* ClickCommand */ 12 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected ClickCommand") : command._0;
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* ClickCommand */ 12,
                            _0: Curry._2(ClickCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback, tmp, playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* CheckboxParamValue */ 2:
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* CheckboxCommand */ 16,
                            _0: CheckboxCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback(playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* SelectInputParamValue */ 3:
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* SelectCommand */ 17,
                            _0: SelectCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback(playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* RadioInputParamValue */ 4:
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* RadioCommand */ 18,
                            _0: RadioCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback(playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* URLParamValue */ 5:
                    var match = playbackParamValue._0;
                    var urlCommandType = match.urlCommandType;
                    var url = match.url;
                    var tmp$1;
                    switch(urlCommandType.TAG | 0){
                        case /* NewWindowWithUrlCommand */ 0:
                            tmp$1 = {
                                TAG: /* NewWindowWithUrlCommand */ 1,
                                _0: {
                                    url: url,
                                    title: undefined,
                                    focusStatus: urlCommandType._0
                                }
                            };
                            break;
                        case /* NewTabWithUrlCommand */ 1:
                            tmp$1 = {
                                TAG: /* NewTabWithUrlCommand */ 3,
                                _0: {
                                    url: url,
                                    title: undefined,
                                    tabRef: urlCommandType._0,
                                    windowRef: urlCommandType._1,
                                    focusStatus: urlCommandType._2
                                }
                            };
                            break;
                        case /* URLCommand */ 2:
                            tmp$1 = {
                                TAG: /* URLCommand */ 6,
                                _0: {
                                    url: url,
                                    title: undefined,
                                    tabRef: urlCommandType._0
                                }
                            };
                            break;
                    }
                    return {
                        id: cmdWithContext.id,
                        command: tmp$1,
                        contextGlobal: {
                            windowRef: contextGlobal.windowRef,
                            tabRef: contextGlobal.tabRef,
                            url: url,
                            focusStatus: contextGlobal.focusStatus,
                            title: contextGlobal.title,
                            frame: contextGlobal.frame,
                            windowGeometry: contextGlobal.windowGeometry,
                            targetBoundingRect: contextGlobal.targetBoundingRect,
                            timestamp: contextGlobal.timestamp,
                            htmlSnapshot: contextGlobal.htmlSnapshot,
                            screenshot: contextGlobal.screenshot,
                            croppedScreenshot: contextGlobal.croppedScreenshot,
                            preconditions: contextGlobal.preconditions,
                            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                        }
                    };
                case /* DownloadParamValue */ 6:
                    var tmp$2;
                    tmp$2 = typeof command === "number" || command.TAG !== /* DownloadCommand */ 32 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected DownloadCommand") : command._0;
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* DownloadCommand */ 32,
                            _0: DownloadCommand$SmartcutsMacros.PlaybackParamValue.toCommandValueForPlayback(tmp$2, playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* GoogleSheetsParamValue */ 7:
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* GoogleSheetsCommand */ 33,
                            _0: GoogleSheetsCommand$SmartcutsMacros.PlaybackParamValue.toPlaybackCommandValue(playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* LoopParamValue */ 8:
                    var tmp$3;
                    tmp$3 = typeof command === "number" || command.TAG !== /* LoopCommand */ 35 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected ClickCommand") : command._0;
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* LoopCommand */ 35,
                            _0: LoopCommand$SmartcutsMacros.PlaybackParamValue.toPlaybackCommandValue(tmp$3, playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* UploadParamValue */ 9:
                    var tmp$4;
                    tmp$4 = typeof command === "number" || command.TAG !== /* UploadCommand */ 41 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected ClickCommand") : command._0;
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* UploadCommand */ 41,
                            _0: UploadCommand$SmartcutsMacros.PlaybackParamValue.toPlaybackCommandValue(tmp$4, playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
                case /* WithElementGroupsParamValue */ 10:
                    var tmp$5;
                    tmp$5 = typeof command === "number" || command.TAG !== /* WithElementGroupsCommand */ 43 ? Util$SmartcutsMacros.logAndRaiseJsError("Expected ClickCommand") : command._0;
                    return {
                        id: cmdWithContext.id,
                        command: {
                            TAG: /* WithElementGroupsCommand */ 43,
                            _0: WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.toPlaybackCommandValue(tmp$5, playbackParamValue._0)
                        },
                        contextGlobal: cmdWithContext.contextGlobal
                    };
            }
        }, commandLog);
        if (playbackParamValue.TAG !== /* URLParamValue */ 5) {
            return commandLog_2;
        }
        var newUrl = playbackParamValue._0.url;
        var matchingTabRefOfUpdatedUrl = Belt_List.getExn(commandLog_2, commandIndex).contextGlobal.tabRef;
        var oldUrl = Belt_List.getExn(commandLog, commandIndex).contextGlobal.url;
        return $$Array.to_list($$Array.map(function(commandWithContext) {
            var contextGlobal = commandWithContext.contextGlobal;
            if (!(Caml_obj.caml_equal(contextGlobal.tabRef, matchingTabRefOfUpdatedUrl) && contextGlobal.url === oldUrl)) {
                return commandWithContext;
            }
            var command = commandWithContext.command;
            var tmp;
            if (typeof command === "number" || command.TAG !== /* FocusTabCommand */ 5) {
                tmp = command;
            } else {
                var cmdVal = command._0;
                tmp = {
                    TAG: /* FocusTabCommand */ 5,
                    _0: {
                        tabRef: cmdVal.tabRef,
                        url: newUrl,
                        title: cmdVal.title
                    }
                };
            }
            return {
                id: commandWithContext.id,
                command: tmp,
                contextGlobal: {
                    windowRef: contextGlobal.windowRef,
                    tabRef: contextGlobal.tabRef,
                    url: newUrl,
                    focusStatus: contextGlobal.focusStatus,
                    title: contextGlobal.title,
                    frame: contextGlobal.frame,
                    windowGeometry: contextGlobal.windowGeometry,
                    targetBoundingRect: contextGlobal.targetBoundingRect,
                    timestamp: contextGlobal.timestamp,
                    htmlSnapshot: contextGlobal.htmlSnapshot,
                    screenshot: contextGlobal.screenshot,
                    croppedScreenshot: contextGlobal.croppedScreenshot,
                    preconditions: contextGlobal.preconditions,
                    maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                }
            };
        }, $$Array.of_list(commandLog_2)));
    });
}
function populateSmartcutParam(smartcutParam, playbackValue) {
    var match = smartcutParam.param;
    var param1;
    switch(match.TAG | 0){
        case /* AddTextInputParam */ 0:
            if (playbackValue.TAG === /* AddTextInputParamValue */ 0) {
                var match$1 = playbackValue._0;
                var match$2 = match._0;
                param1 = {
                    TAG: /* AddTextInputParam */ 0,
                    _0: {
                        targetLocator: match$1.targetLocator,
                        originalLabeledAddText: match$1.labeledAddTextInput,
                        playbackFormLabel: match$2.playbackFormLabel,
                        enums: match$2.enums
                    }
                };
            } else {
                param1 = smartcutParam.param;
            }
            break;
        case /* CheckboxParam */ 2:
            var match$3 = match._0;
            if (match$3.originalCheckboxChoice.TAG === /* SingleCheckbox */ 0) {
                if (playbackValue.TAG === /* CheckboxParamValue */ 2) {
                    var match$4 = playbackValue._0;
                    param1 = match$4.TAG === /* SingleCheckbox */ 0 ? {
                        TAG: /* CheckboxParam */ 2,
                        _0: {
                            originalCheckboxChoice: {
                                TAG: /* SingleCheckbox */ 0,
                                _0: match$4._0,
                                _1: match$4._1
                            },
                            playbackFormLabel: match$3.playbackFormLabel
                        }
                    } : smartcutParam.param;
                } else {
                    param1 = smartcutParam.param;
                }
            } else if (playbackValue.TAG === /* CheckboxParamValue */ 2) {
                var checkboxGroupWithChosenValues = playbackValue._0;
                param1 = checkboxGroupWithChosenValues.TAG === /* SingleCheckbox */ 0 ? smartcutParam.param : {
                    TAG: /* CheckboxParam */ 2,
                    _0: {
                        originalCheckboxChoice: {
                            TAG: /* CheckboxGroup */ 1,
                            _0: checkboxGroupWithChosenValues._0
                        },
                        playbackFormLabel: match$3.playbackFormLabel
                    }
                };
            } else {
                param1 = smartcutParam.param;
            }
            break;
        case /* SelectInputParam */ 3:
            if (playbackValue.TAG === /* SelectInputParamValue */ 3) {
                var match$5 = playbackValue._0;
                param1 = {
                    TAG: /* SelectInputParam */ 3,
                    _0: {
                        targetLocator: match$5.targetLocator,
                        originalLabeledValue: match$5.labeledValue,
                        playbackFormLabel: match._0.playbackFormLabel
                    }
                };
            } else {
                param1 = smartcutParam.param;
            }
            break;
        case /* RadioInputParam */ 4:
            if (playbackValue.TAG === /* RadioInputParamValue */ 4) {
                var match$6 = playbackValue._0;
                var match$7 = match$6.labeledValue;
                var value = match$7.value.selected.value;
                var match$8 = match._0;
                var match$9 = match$8.originalLabeledValue.value;
                var options = match$9.options;
                var index1 = ArrayUtils$SmartcutsMacros.shortcutWithIndex(function(param, index) {
                    if (Caml_obj.caml_equal(param.value, value)) {
                        return index;
                    }
                }, options);
                param1 = {
                    TAG: /* RadioInputParam */ 4,
                    _0: {
                        targetLocator: match$6.targetLocator,
                        originalLabeledValue: {
                            label: match$7.label,
                            value: {
                                options: options,
                                indexSelected: index1 !== undefined ? index1 : match$9.indexSelected
                            }
                        },
                        playbackFormLabel: match$8.playbackFormLabel
                    }
                };
            } else {
                param1 = smartcutParam.param;
            }
            break;
        case /* URLParam */ 5:
            if (playbackValue.TAG === /* URLParamValue */ 5) {
                var match$10 = playbackValue._0;
                param1 = {
                    TAG: /* URLParam */ 5,
                    _0: {
                        originalUrl: match$10.url,
                        urlPattern: match._0.urlPattern,
                        urlCommandType: match$10.urlCommandType
                    }
                };
            } else {
                param1 = smartcutParam.param;
            }
            break;
        case /* GoogleSheetsParam */ 7:
            var match$11 = match._0;
            if (match$11.TAG === /* UpdateCellParam */ 0) {
                if (playbackValue.TAG === /* GoogleSheetsParamValue */ 7) {
                    var match$12 = playbackValue._0;
                    var match$13 = match$11._0;
                    if (match$12.TAG === /* UpdateCellParamValue */ 0) {
                        var match$14 = match$12._0;
                        param1 = {
                            TAG: /* GoogleSheetsParam */ 7,
                            _0: {
                                TAG: /* UpdateCellParam */ 0,
                                _0: {
                                    spreadsheetId: match$14.spreadsheetId,
                                    sheetName: match$14.sheetName,
                                    colNames: match$14.colNames,
                                    keyColumnIndex: match$14.keyColumnIndex,
                                    keyColumnValue: match$14.keyColumnValue,
                                    updatedColIndex: match$14.updatedColIndex,
                                    cellUpdate: {
                                        fromValue: match$13.cellUpdate.fromValue,
                                        toValue: match$14.cellUpdate
                                    },
                                    playbackFormLabel: match$13.playbackFormLabel
                                }
                            }
                        };
                    } else {
                        param1 = smartcutParam.param;
                    }
                } else {
                    param1 = smartcutParam.param;
                }
            } else if (playbackValue.TAG === /* GoogleSheetsParamValue */ 7) {
                var match$15 = playbackValue._0;
                if (match$15.TAG === /* UpdateCellParamValue */ 0) {
                    param1 = smartcutParam.param;
                } else {
                    var match$16 = match$15._0;
                    param1 = {
                        TAG: /* GoogleSheetsParam */ 7,
                        _0: {
                            TAG: /* UpsertRowParam */ 1,
                            _0: {
                                spreadsheetId: match$16.spreadsheetId,
                                sheetName: match$16.sheetName,
                                colNames: match$16.colNames,
                                keyColumnIndex: match$16.keyColumnIndex,
                                keyColumnValue: match$16.keyColumnValue,
                                rowData: match$16.rowData,
                                playbackFormLabel: match$11._0.playbackFormLabel
                            }
                        }
                    };
                }
            } else {
                param1 = smartcutParam.param;
            }
            break;
        default:
            param1 = smartcutParam.param;
    }
    return {
        firstCommandIndex: smartcutParam.firstCommandIndex,
        otherCommandIndexes: smartcutParam.otherCommandIndexes,
        param: param1
    };
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.Update = Update;
exports.stringify = stringify$1;
exports.minify = minify;
exports.fromSmartcutParam = fromSmartcutParam;
exports.ValuesByCommandIndex = ValuesByCommandIndex;
exports.substitutePlaybackValuesIntoCommandLog = substitutePlaybackValuesIntoCommandLog;
exports.populateSmartcutParam = populateSmartcutParam; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 9154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_MapInt = __webpack_require__(91094);
var Belt_Option = __webpack_require__(46517);
var Smartcut$SmartcutsMacros = __webpack_require__(95418);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var UserCredential$SmartcutsMacros = __webpack_require__(98207);
var PlaybackParamValue$SmartcutsMacros = __webpack_require__(32451);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "smartcutParamValuesByCommandIndex",
            PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v.smartcutParamValuesByCommandIndex)
        ],
        [
            "credentialDbIdsByHostname",
            CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(UserCredential$SmartcutsMacros.DbId.id_encode, v.credentialDbIdsByHostname)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutParamValuesByCommandIndex = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutParamValuesByCommandIndex"), null));
    if (smartcutParamValuesByCommandIndex.TAG === /* Ok */ 0) {
        var credentialDbIdsByHostname = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(UserCredential$SmartcutsMacros.DbId.id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialDbIdsByHostname"), null));
        if (credentialDbIdsByHostname.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    smartcutParamValuesByCommandIndex: smartcutParamValuesByCommandIndex._0,
                    credentialDbIdsByHostname: credentialDbIdsByHostname._0
                }
            };
        }
        var e = credentialDbIdsByHostname._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".credentialDbIdsByHostname" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = smartcutParamValuesByCommandIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutParamValuesByCommandIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function init(param) {
    return {
        smartcutParamValuesByCommandIndex: undefined,
        credentialDbIdsByHostname: undefined
    };
}
function minify(param) {
    return {
        smartcutParamValuesByCommandIndex: PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.minify(param.smartcutParamValuesByCommandIndex),
        credentialDbIdsByHostname: param.credentialDbIdsByHostname
    };
}
function size(param) {
    return Belt_MapInt.size(param.smartcutParamValuesByCommandIndex);
}
function substitutePlaybackValuesIntoCommandLog(commandLog, param) {
    return PlaybackParamValue$SmartcutsMacros.substitutePlaybackValuesIntoCommandLog(commandLog, param.smartcutParamValuesByCommandIndex);
}
function getSmartcutParamValuesByCommandIndex(param) {
    return param.smartcutParamValuesByCommandIndex;
}
function preserveObjectUrlInPlaybackData(values) {
    return PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.preserveObjectUrlInPlaybackData(values.smartcutParamValuesByCommandIndex).then(function(nextSmartcutParamValuesByCommandIndex) {
        return Promise.resolve({
            smartcutParamValuesByCommandIndex: nextSmartcutParamValuesByCommandIndex,
            credentialDbIdsByHostname: values.credentialDbIdsByHostname
        });
    });
}
function t_encode$1(v) {
    if (v.TAG === /* SmartcutParam */ 0) {
        return [
            "SmartcutParam",
            Smartcut$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
        ];
    } else {
        return [
            "CredentialParam",
            Decco.stringToJson(v._0)
        ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CredentialParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CredentialParam */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SmartcutParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Smartcut$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SmartcutParam */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var Param = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.init = init;
exports.minify = minify;
exports.size = size;
exports.substitutePlaybackValuesIntoCommandLog = substitutePlaybackValuesIntoCommandLog;
exports.getSmartcutParamValuesByCommandIndex = getSmartcutParamValuesByCommandIndex;
exports.preserveObjectUrlInPlaybackData = preserveObjectUrlInPlaybackData;
exports.Param = Param; /* Smartcut-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 36512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Format = (__webpack_require__(74201)/* ["default"] */ .Z);
var AddDays = (__webpack_require__(77349)/* ["default"] */ .Z);
var IsAfter = (__webpack_require__(42699)/* ["default"] */ .Z);
var SetDate = (__webpack_require__(34176)/* ["default"] */ .Z);
var SubDays = (__webpack_require__(7069)/* ["default"] */ .Z);
var AddWeeks = (__webpack_require__(63500)/* ["default"] */ .Z);
var SetHours = (__webpack_require__(37042)/* ["default"] */ .Z);
var AddMonths = (__webpack_require__(11640)/* ["default"] */ .Z);
var AddMinutes = (__webpack_require__(58545)/* ["default"] */ .Z);
var SetMinutes = (__webpack_require__(4543)/* ["default"] */ .Z);
var LastDayOfWeek = (__webpack_require__(90065)/* ["default"] */ .Z);
var LastDayOfMonth = (__webpack_require__(8230)/* ["default"] */ .Z);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var PlaybackOptions$SmartcutsMacros = __webpack_require__(84094);
var SmartcutExecution$SmartcutsMacros = __webpack_require__(32062);
var _map = {
    "ACTIVE": "ACTIVE",
    "PAUSED": "PAUSED",
    "ARCHIVED": "ARCHIVED"
};
function tToJs(param) {
    return param;
}
function tFromJs(param) {
    return _map[param];
}
var Status = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "ScheduledTrigger.Status.t",
    tToJs: tToJs,
    tFromJs: tFromJs
});
function hourMinute_encode(v) {
    return [
        Decco.intToJson(v[0]),
        Decco.intToJson(v[1])
    ];
}
function hourMinute_decode(v) {
    var match = Js_json.classify(v);
    if (typeof match === "number") {
        return Decco.error(undefined, "Not a tuple", v);
    }
    if (match.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a tuple", v);
    }
    var match$1 = match._0;
    if (match$1.length !== 2) {
        return Decco.error(undefined, "Incorrect cardinality", v);
    }
    var v0 = match$1[0];
    var v1 = match$1[1];
    var match$2 = Decco.intFromJson(v0);
    var match$3 = Decco.intFromJson(v1);
    if (match$2.TAG === /* Ok */ 0) {
        if (match$3.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: [
                    match$2._0,
                    match$3._0
                ]
            };
        }
        var e = match$3._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = match$2._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: "[0]" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function dayOfWeek_encode(v) {
    switch(v){
        case /* Sunday */ 0:
            return [
                "Sunday"
            ];
        case /* Monday */ 1:
            return [
                "Monday"
            ];
        case /* Tuesday */ 2:
            return [
                "Tuesday"
            ];
        case /* Wednesday */ 3:
            return [
                "Wednesday"
            ];
        case /* Thursday */ 4:
            return [
                "Thursday"
            ];
        case /* Friday */ 5:
            return [
                "Friday"
            ];
        case /* Saturday */ 6:
            return [
                "Saturday"
            ];
    }
}
function dayOfWeek_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Friday":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Friday */ 5
                    };
                }
            case "Monday":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Monday */ 1
                    };
                }
            case "Saturday":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Saturday */ 6
                    };
                }
            case "Sunday":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Sunday */ 0
                    };
                }
            case "Thursday":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Thursday */ 4
                    };
                }
            case "Tuesday":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Tuesday */ 2
                    };
                }
            case "Wednesday":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Wednesday */ 3
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function schedulePeriod_encode(v) {
    switch(v.TAG | 0){
        case /* EveryDay */ 0:
            return [
                "EveryDay",
                hourMinute_encode(v._0)
            ];
        case /* EveryWeek */ 1:
            return [
                "EveryWeek",
                dayOfWeek_encode(v._0),
                hourMinute_encode(v._1)
            ];
        case /* EveryMonth */ 2:
            return [
                "EveryMonth",
                Decco.intToJson(v._0),
                hourMinute_encode(v._1)
            ];
        case /* EveryLastDayOfTheMonth */ 3:
            return [
                "EveryLastDayOfTheMonth",
                hourMinute_encode(v._0)
            ];
    }
}
function schedulePeriod_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "EveryDay":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = hourMinute_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* EveryDay */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "EveryLastDayOfTheMonth":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = hourMinute_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* EveryLastDayOfTheMonth */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "EveryMonth":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = hourMinute_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* EveryMonth */ 2,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "EveryWeek":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = dayOfWeek_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = hourMinute_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* EveryWeek */ 1,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$4 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function schedulePeriodHourMinuteGet(schedulePeriod) {
    switch(schedulePeriod.TAG | 0){
        case /* EveryWeek */ 1:
        case /* EveryMonth */ 2:
            return schedulePeriod._1;
        case /* EveryDay */ 0:
        case /* EveryLastDayOfTheMonth */ 3:
            return schedulePeriod._0;
    }
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "installedSmartcutId",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
        ],
        [
            "status",
            Curry._1(Status.t_encode, v.status)
        ],
        [
            "schedulePeriod",
            DeccoUtils$SmartcutsMacros.decodable_encode(schedulePeriod_encode, v.schedulePeriod)
        ],
        [
            "dataSource",
            DeccoUtils$SmartcutsMacros.decodable_encode(SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_encode, v.dataSource)
        ],
        [
            "playbackOptions",
            DeccoUtils$SmartcutsMacros.decodable_encode(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode, v.playbackOptions)
        ],
        [
            "commandSchemaVersion",
            Decco.stringToJson(v.commandSchemaVersion)
        ],
        [
            "playbackOptionsSchemaVersion",
            Decco.stringToJson(v.playbackOptionsSchemaVersion)
        ],
        [
            "maybeLastCheckedAt",
            Decco.optionToJson(Decco.floatToJson, v.maybeLastCheckedAt)
        ],
        [
            "updatedAt",
            Decco.floatToJson(v.updatedAt)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
        if (installedSmartcutId.TAG === /* Ok */ 0) {
            var status = Curry._1(Status.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
            if (status.TAG === /* Ok */ 0) {
                var schedulePeriod = DeccoUtils$SmartcutsMacros.decodable_decode(schedulePeriod_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedulePeriod"), null));
                if (schedulePeriod.TAG === /* Ok */ 0) {
                    var dataSource = DeccoUtils$SmartcutsMacros.decodable_decode(SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSource"), null));
                    if (dataSource.TAG === /* Ok */ 0) {
                        var playbackOptions = DeccoUtils$SmartcutsMacros.decodable_decode(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackOptions"), null));
                        if (playbackOptions.TAG === /* Ok */ 0) {
                            var commandSchemaVersion = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandSchemaVersion"), null));
                            if (commandSchemaVersion.TAG === /* Ok */ 0) {
                                var playbackOptionsSchemaVersion = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackOptionsSchemaVersion"), null));
                                if (playbackOptionsSchemaVersion.TAG === /* Ok */ 0) {
                                    var maybeLastCheckedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLastCheckedAt"), null));
                                    if (maybeLastCheckedAt.TAG === /* Ok */ 0) {
                                        var updatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedAt"), null));
                                        if (updatedAt.TAG === /* Ok */ 0) {
                                            return {
                                                TAG: /* Ok */ 0,
                                                _0: {
                                                    id: id._0,
                                                    installedSmartcutId: installedSmartcutId._0,
                                                    status: status._0,
                                                    schedulePeriod: schedulePeriod._0,
                                                    dataSource: dataSource._0,
                                                    playbackOptions: playbackOptions._0,
                                                    commandSchemaVersion: commandSchemaVersion._0,
                                                    playbackOptionsSchemaVersion: playbackOptionsSchemaVersion._0,
                                                    maybeLastCheckedAt: maybeLastCheckedAt._0,
                                                    updatedAt: updatedAt._0
                                                }
                                            };
                                        }
                                        var e = updatedAt._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".updatedAt" + e.path,
                                                message: e.message,
                                                value: e.value
                                            }
                                        };
                                    }
                                    var e$1 = maybeLastCheckedAt._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".maybeLastCheckedAt" + e$1.path,
                                            message: e$1.message,
                                            value: e$1.value
                                        }
                                    };
                                }
                                var e$2 = playbackOptionsSchemaVersion._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".playbackOptionsSchemaVersion" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                    }
                                };
                            }
                            var e$3 = commandSchemaVersion._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".commandSchemaVersion" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                }
                            };
                        }
                        var e$4 = playbackOptions._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".playbackOptions" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = dataSource._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".dataSource" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = schedulePeriod._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".schedulePeriod" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            }
            var e$7 = status._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".status" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                }
            };
        }
        var e$8 = installedSmartcutId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".installedSmartcutId" + e$8.path,
                message: e$8.message,
                value: e$8.value
            }
        };
    }
    var e$9 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$9.path,
            message: e$9.message,
            value: e$9.value
        }
    };
}
function make(id, installedSmartcutId, status, schedulePeriodSerialized, dataSourceSerialized, playbackOptionsSerialized, playbackOptionsSchemaVersion, commandSchemaVersion, maybeLastCheckedAt, updatedAt) {
    var decoded = schedulePeriod_decode(JSON.parse(schedulePeriodSerialized));
    var tmp;
    if (decoded.TAG === /* Ok */ 0) {
        tmp = {
            TAG: /* Decoded */ 0,
            _0: decoded._0
        };
    } else {
        console.error(decoded._0);
        tmp = {
            TAG: /* UnableToDecode */ 1,
            _0: JSON.parse(schedulePeriodSerialized)
        };
    }
    var decoded$1 = SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_decode(JSON.parse(dataSourceSerialized));
    var tmp$1;
    if (decoded$1.TAG === /* Ok */ 0) {
        tmp$1 = {
            TAG: /* Decoded */ 0,
            _0: decoded$1._0
        };
    } else {
        console.error(decoded$1._0);
        tmp$1 = {
            TAG: /* UnableToDecode */ 1,
            _0: JSON.parse(dataSourceSerialized)
        };
    }
    var tmp$2;
    if (playbackOptionsSchemaVersion !== PlaybackOptions$SmartcutsMacros.schemaVersion) {
        tmp$2 = {
            TAG: /* UnableToDecode */ 1,
            _0: JSON.parse(playbackOptionsSerialized)
        };
    } else {
        var decoded$2 = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(JSON.parse(playbackOptionsSerialized));
        if (decoded$2.TAG === /* Ok */ 0) {
            tmp$2 = {
                TAG: /* Decoded */ 0,
                _0: decoded$2._0
            };
        } else {
            console.error(decoded$2._0);
            tmp$2 = {
                TAG: /* UnableToDecode */ 1,
                _0: JSON.parse(playbackOptionsSerialized)
            };
        }
    }
    return {
        id: id,
        installedSmartcutId: installedSmartcutId,
        status: status,
        schedulePeriod: tmp,
        dataSource: tmp$1,
        playbackOptions: tmp$2,
        commandSchemaVersion: commandSchemaVersion,
        playbackOptionsSchemaVersion: playbackOptionsSchemaVersion,
        maybeLastCheckedAt: maybeLastCheckedAt,
        updatedAt: updatedAt
    };
}
var LoadedScheduledTrigger = {
    t_encode: t_encode,
    t_decode: t_decode,
    make: make
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "installedSmartcutId",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
        ],
        [
            "schedulePeriod",
            schedulePeriod_encode(v.schedulePeriod)
        ],
        [
            "updatedAt",
            Decco.floatToJson(v.updatedAt)
        ],
        [
            "dataSource",
            SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_encode(v.dataSource)
        ],
        [
            "status",
            Curry._1(Status.t_encode, v.status)
        ],
        [
            "userSpecifiedPlaybackOptions",
            PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v.userSpecifiedPlaybackOptions)
        ],
        [
            "maybeLastCheckedAt",
            Decco.optionToJson(Decco.floatToJson, v.maybeLastCheckedAt)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
        if (installedSmartcutId.TAG === /* Ok */ 0) {
            var schedulePeriod = schedulePeriod_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedulePeriod"), null));
            if (schedulePeriod.TAG === /* Ok */ 0) {
                var updatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedAt"), null));
                if (updatedAt.TAG === /* Ok */ 0) {
                    var dataSource = SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSource"), null));
                    if (dataSource.TAG === /* Ok */ 0) {
                        var status = Curry._1(Status.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
                        if (status.TAG === /* Ok */ 0) {
                            var userSpecifiedPlaybackOptions = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "userSpecifiedPlaybackOptions"), null));
                            if (userSpecifiedPlaybackOptions.TAG === /* Ok */ 0) {
                                var maybeLastCheckedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLastCheckedAt"), null));
                                if (maybeLastCheckedAt.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            id: id._0,
                                            installedSmartcutId: installedSmartcutId._0,
                                            schedulePeriod: schedulePeriod._0,
                                            updatedAt: updatedAt._0,
                                            dataSource: dataSource._0,
                                            status: status._0,
                                            userSpecifiedPlaybackOptions: userSpecifiedPlaybackOptions._0,
                                            maybeLastCheckedAt: maybeLastCheckedAt._0
                                        }
                                    };
                                }
                                var e = maybeLastCheckedAt._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".maybeLastCheckedAt" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = userSpecifiedPlaybackOptions._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".userSpecifiedPlaybackOptions" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = status._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".status" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = dataSource._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".dataSource" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = updatedAt._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".updatedAt" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = schedulePeriod._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".schedulePeriod" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = installedSmartcutId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".installedSmartcutId" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
function fromLoadedScheduledTrigger(loadedTrigger) {
    var match = loadedTrigger.schedulePeriod;
    var match$1 = loadedTrigger.dataSource;
    var match$2 = loadedTrigger.playbackOptions;
    if (match.TAG === /* Decoded */ 0 && match$1.TAG === /* Decoded */ 0 && match$2.TAG === /* Decoded */ 0) {
        return {
            id: loadedTrigger.id,
            installedSmartcutId: loadedTrigger.installedSmartcutId,
            schedulePeriod: match._0,
            updatedAt: loadedTrigger.updatedAt,
            dataSource: match$1._0,
            status: loadedTrigger.status,
            userSpecifiedPlaybackOptions: match$2._0,
            maybeLastCheckedAt: loadedTrigger.maybeLastCheckedAt
        };
    }
}
var weekdays = [
    /* Sunday */ 0,
    /* Monday */ 1,
    /* Tuesday */ 2,
    /* Wednesday */ 3,
    /* Thursday */ 4,
    /* Friday */ 5,
    /* Saturday */ 6
];
function dayOfWeekToString(v) {
    switch(v){
        case /* Sunday */ 0:
            return "Sunday";
        case /* Monday */ 1:
            return "Monday";
        case /* Tuesday */ 2:
            return "Tuesday";
        case /* Wednesday */ 3:
            return "Wednesday";
        case /* Thursday */ 4:
            return "Thursday";
        case /* Friday */ 5:
            return "Friday";
        case /* Saturday */ 6:
            return "Saturday";
    }
}
function maybeDayOfWeekFromString(stringValue) {
    return ArrayUtils$SmartcutsMacros.firstMatch(function(dayOfWeek) {
        return stringValue === dayOfWeekToString(dayOfWeek);
    }, weekdays);
}
function nextAvailableScheduleTime(maybeLastCheckedAt, param) {
    return AddMinutes(OptionUtils$SmartcutsMacros.withDefault(new Date(), maybeLastCheckedAt), 2);
}
function nextScheduledTimeForSchedulePeriod(maybeLastCheckedAt, schedulePeriod) {
    var nextAvailableTime = nextAvailableScheduleTime(maybeLastCheckedAt, undefined);
    switch(schedulePeriod.TAG | 0){
        case /* EveryDay */ 0:
            var match = schedulePeriod._0;
            var nextDateTime = SetMinutes(SetHours(nextAvailableTime, match[0]), match[1]);
            if (IsAfter(nextDateTime, nextAvailableTime)) {
                return nextDateTime;
            } else {
                return AddDays(nextDateTime, 1);
            }
        case /* EveryWeek */ 1:
            var match$1 = schedulePeriod._1;
            var nextDateTime$1 = SetMinutes(SetHours(SubDays(LastDayOfWeek(nextAvailableTime), 6 - weekdays.indexOf(schedulePeriod._0) | 0), match$1[0]), match$1[1]);
            if (IsAfter(nextDateTime$1, nextAvailableTime)) {
                return nextDateTime$1;
            } else {
                return AddWeeks(nextDateTime$1, 1);
            }
        case /* EveryMonth */ 2:
            var match$2 = schedulePeriod._1;
            var nextDateTime$2 = SetMinutes(SetHours(SetDate(nextAvailableTime, schedulePeriod._0), match$2[0]), match$2[1]);
            if (IsAfter(nextDateTime$2, nextAvailableTime)) {
                return nextDateTime$2;
            } else {
                return AddMonths(nextDateTime$2, 1);
            }
        case /* EveryLastDayOfTheMonth */ 3:
            var match$3 = schedulePeriod._0;
            var nextDateTime$3 = SetMinutes(SetHours(LastDayOfMonth(nextAvailableTime), match$3[0]), match$3[1]);
            if (IsAfter(nextDateTime$3, nextAvailableTime)) {
                return nextDateTime$3;
            } else {
                return AddMonths(nextDateTime$3, 1);
            }
    }
}
function nextScheduledTime(param1) {
    var arg = OptionUtils$SmartcutsMacros.map(param1.maybeLastCheckedAt, function(prim) {
        return new Date(prim);
    });
    return nextScheduledTimeForSchedulePeriod(Caml_option.some(function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(new Date(param1.updatedAt))), param1.schedulePeriod);
}
function maybePeriodInMinutes(param) {
    switch(param.schedulePeriod.TAG | 0){
        case /* EveryDay */ 0:
            return 1440;
        case /* EveryWeek */ 1:
            return 10080;
        case /* EveryMonth */ 2:
        case /* EveryLastDayOfTheMonth */ 3:
            return;
    }
}
function maybeUpdateNextScheduledTime(param) {
    var schedulePeriod = param.schedulePeriod;
    var now = new Date();
    switch(schedulePeriod.TAG | 0){
        case /* EveryDay */ 0:
        case /* EveryWeek */ 1:
            return;
        case /* EveryMonth */ 2:
            var match = schedulePeriod._1;
            return SetMinutes(SetHours(SetDate(AddMonths(now, 1), schedulePeriod._0), match[0]), match[1]).getTime();
        case /* EveryLastDayOfTheMonth */ 3:
            var match$1 = schedulePeriod._0;
            return SetMinutes(SetHours(LastDayOfMonth(AddMonths(now, 1)), match$1[0]), match$1[1]).getTime();
    }
}
function toAlarmCreateInfo(scheduledTrigger) {
    var when_ = nextScheduledTime(scheduledTrigger).getTime();
    var periodInMinutes = maybePeriodInMinutes(scheduledTrigger);
    var tmp = {
        when: when_
    };
    if (periodInMinutes !== undefined) {
        tmp.periodInMinutes = Caml_option.valFromOption(periodInMinutes);
    }
    return tmp;
}
function createBrowserAlarm(scheduledTrigger) {
    browser.alarms.create(scheduledTrigger.id, toAlarmCreateInfo(scheduledTrigger));
}
function humanizeHourMinute(param) {
    return Format(SetMinutes(SetHours(new Date(), param[0]), param[1]), "hh:mm a");
}
function humanizeSchedulePeriod(v) {
    switch(v.TAG | 0){
        case /* EveryDay */ 0:
            return "Every day at " + humanizeHourMinute(v._0);
        case /* EveryWeek */ 1:
            return "Every week on " + (dayOfWeekToString(v._0) + (" at " + humanizeHourMinute(v._1)));
        case /* EveryMonth */ 2:
            return "Every month on " + (StringUtils$SmartcutsMacros.withOrd(v._0) + (" at " + humanizeHourMinute(v._1)));
        case /* EveryLastDayOfTheMonth */ 3:
            return "The last day of every  month at " + humanizeHourMinute(v._0);
    }
}
var allSteps = [
    /* ScheduledDays */ 0,
    /* NTimesInADay */ 1,
    /* ScheduledTimes */ 2
];
function configStepToString(v) {
    switch(v){
        case /* ScheduledDays */ 0:
            return "ScheduledDays";
        case /* NTimesInADay */ 1:
            return "NTimesInADay";
        case /* ScheduledTimes */ 2:
            return "ScheduledTimes";
    }
}
function nTimesInADayToString(v) {
    switch(v){
        case /* Once */ 0:
            return "Once";
        case /* ThreeTimes */ 1:
            return "Three times";
        case /* ManyTimes */ 2:
            return "X times (you can customize)";
    }
}
function scheduledDaysToString(scheduledDays) {
    return Belt_Array.map(scheduledDays, dayOfWeekToString);
}
function scheduledTimesToString(scheduledTimes) {
    return Belt_Array.map(scheduledTimes, humanizeHourMinute);
}
var allNTimesInADay = [
    /* Once */ 0,
    /* ThreeTimes */ 1,
    /* ManyTimes */ 2
];
var Idiomatic = {
    allSteps: allSteps,
    configStepToString: configStepToString,
    nTimesInADayToString: nTimesInADayToString,
    scheduledDaysToString: scheduledDaysToString,
    scheduledTimesToString: scheduledTimesToString,
    allNTimesInADay: allNTimesInADay
};
exports.Status = Status;
exports.hourMinute_encode = hourMinute_encode;
exports.hourMinute_decode = hourMinute_decode;
exports.dayOfWeek_encode = dayOfWeek_encode;
exports.dayOfWeek_decode = dayOfWeek_decode;
exports.schedulePeriod_encode = schedulePeriod_encode;
exports.schedulePeriod_decode = schedulePeriod_decode;
exports.schedulePeriodHourMinuteGet = schedulePeriodHourMinuteGet;
exports.LoadedScheduledTrigger = LoadedScheduledTrigger;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.fromLoadedScheduledTrigger = fromLoadedScheduledTrigger;
exports.weekdays = weekdays;
exports.dayOfWeekToString = dayOfWeekToString;
exports.maybeDayOfWeekFromString = maybeDayOfWeekFromString;
exports.nextScheduledTimeForSchedulePeriod = nextScheduledTimeForSchedulePeriod;
exports.nextScheduledTime = nextScheduledTime;
exports.maybePeriodInMinutes = maybePeriodInMinutes;
exports.maybeUpdateNextScheduledTime = maybeUpdateNextScheduledTime;
exports.createBrowserAlarm = createBrowserAlarm;
exports.humanizeHourMinute = humanizeHourMinute;
exports.humanizeSchedulePeriod = humanizeSchedulePeriod;
exports.Idiomatic = Idiomatic; /* Status Not a pure module */ 


/***/ }),

/***/ 32062:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Uuid = __webpack_require__(97466);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_MapInt = __webpack_require__(91094);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
var PlaybackValues$SmartcutsMacros = __webpack_require__(9154);
var UserCredential$SmartcutsMacros = __webpack_require__(98207);
var PlaybackOptions$SmartcutsMacros = __webpack_require__(84094);
var Browser__Identity$SmartcutsMacros = __webpack_require__(60051);
var GoogleSheetHelpers$SmartcutsMacros = __webpack_require__(42828);
var PlaybackParamValue$SmartcutsMacros = __webpack_require__(32451);
function multiUrlTriggeringTrigger_encode(v) {
    if (v) {
        return [
            "PopupMultiUrlTrigger"
        ];
    } else {
        return [
            "ContextMenuMultiUrlTrigger"
        ];
    }
}
function multiUrlTriggeringTrigger_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContextMenuMultiUrlTrigger":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContextMenuMultiUrlTrigger */ 0
                    };
                }
            case "PopupMultiUrlTrigger":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PopupMultiUrlTrigger */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "trigger",
            multiUrlTriggeringTrigger_encode(v.trigger)
        ],
        [
            "credentialDbIdsByHostname",
            CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(UserCredential$SmartcutsMacros.DbId.id_encode, v.credentialDbIdsByHostname)
        ],
        [
            "hrefs",
            Decco.arrayToJson(Decco.stringToJson, v.hrefs)
        ],
        [
            "paramValuesByCommandIndex",
            PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v.paramValuesByCommandIndex)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var trigger = multiUrlTriggeringTrigger_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
    if (trigger.TAG === /* Ok */ 0) {
        var credentialDbIdsByHostname = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(UserCredential$SmartcutsMacros.DbId.id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialDbIdsByHostname"), null));
        if (credentialDbIdsByHostname.TAG === /* Ok */ 0) {
            var hrefs = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hrefs"), null));
            if (hrefs.TAG === /* Ok */ 0) {
                var paramValuesByCommandIndex = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paramValuesByCommandIndex"), null));
                if (paramValuesByCommandIndex.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            trigger: trigger._0,
                            credentialDbIdsByHostname: credentialDbIdsByHostname._0,
                            hrefs: hrefs._0,
                            paramValuesByCommandIndex: paramValuesByCommandIndex._0
                        }
                    };
                }
                var e = paramValuesByCommandIndex._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".paramValuesByCommandIndex" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = hrefs._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".hrefs" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = credentialDbIdsByHostname._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".credentialDbIdsByHostname" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = trigger._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".trigger" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function toArrayOfPlaybackValues(param) {
    var paramValuesByCommandIndex = param.paramValuesByCommandIndex;
    return Belt_Array.map(param.hrefs, function(href) {
        return Belt_MapInt.update(paramValuesByCommandIndex, 0, function(maybePlaybackParamValue) {
            return Belt_Option.map(maybePlaybackParamValue, function(paramValue) {
                if (paramValue.TAG === /* URLParamValue */ 5) {
                    return {
                        TAG: /* URLParamValue */ 5,
                        _0: {
                            url: href,
                            urlCommandType: paramValue._0.urlCommandType
                        }
                    };
                } else {
                    return paramValue;
                }
            });
        });
    });
}
var MultiUrlTriggeringWithCreds = {
    t_encode: t_encode,
    t_decode: t_decode,
    toArrayOfPlaybackValues: toArrayOfPlaybackValues
};
function failedState_encode(v) {
    return Js_dict.fromArray([
        [
            "failedReason",
            failedReason_encode(v.failedReason)
        ],
        [
            "numCompleted",
            Decco.intToJson(v.numCompleted)
        ]
    ]);
}
function googleSheet_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var spreadsheetUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetUrl"), null));
        if (spreadsheetUrl.TAG === /* Ok */ 0) {
            var spreadsheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetName"), null));
            if (spreadsheetName.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        spreadsheetId: spreadsheetId._0,
                        spreadsheetUrl: spreadsheetUrl._0,
                        spreadsheetName: spreadsheetName._0
                    }
                };
            }
            var e = spreadsheetName._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".spreadsheetName" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = spreadsheetUrl._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".spreadsheetUrl" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function failedState_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var failedReason = failedReason_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedReason"), null));
    if (failedReason.TAG === /* Ok */ 0) {
        var numCompleted = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCompleted"), null));
        if (numCompleted.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    failedReason: failedReason._0,
                    numCompleted: numCompleted._0
                }
            };
        }
        var e = numCompleted._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".numCompleted" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = failedReason._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".failedReason" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function googleSheet_encode(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "spreadsheetUrl",
            Decco.stringToJson(v.spreadsheetUrl)
        ],
        [
            "spreadsheetName",
            Decco.stringToJson(v.spreadsheetName)
        ]
    ]);
}
function failedReason_encode(v) {
    switch(v){
        case /* DidRejectPermission */ 0:
            return [
                "DidRejectPermission"
            ];
        case /* DidNotGetOAuthTokenForGSheet */ 1:
            return [
                "DidNotGetOAuthTokenForGSheet"
            ];
        case /* CouldNotFindGoogleSheet */ 2:
            return [
                "CouldNotFindGoogleSheet"
            ];
        case /* ErrorWhileFetchingGoogleSheet */ 3:
            return [
                "ErrorWhileFetchingGoogleSheet"
            ];
        case /* UnableToDecodeSmartcutParams */ 4:
            return [
                "UnableToDecodeSmartcutParams"
            ];
    }
}
function failedReason_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CouldNotFindGoogleSheet":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CouldNotFindGoogleSheet */ 2
                    };
                }
            case "DidNotGetOAuthTokenForGSheet":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidNotGetOAuthTokenForGSheet */ 1
                    };
                }
            case "DidRejectPermission":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidRejectPermission */ 0
                    };
                }
            case "ErrorWhileFetchingGoogleSheet":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ErrorWhileFetchingGoogleSheet */ 3
                    };
                }
            case "UnableToDecodeSmartcutParams":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UnableToDecodeSmartcutParams */ 4
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function dataSource_encode(v) {
    switch(v.TAG | 0){
        case /* Form */ 0:
            return [
                "Form",
                PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v._0)
            ];
        case /* GoogleSheet */ 1:
            return [
                "GoogleSheet",
                googleSheet_encode(v._0)
            ];
        case /* MultiUrlTriggering */ 2:
            return [
                "MultiUrlTriggering",
                multiUrlTriggeringTrigger_encode(v._0),
                Decco.arrayToJson(PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode, v._1)
            ];
        case /* FormWithCreds */ 3:
            return [
                "FormWithCreds",
                PlaybackValues$SmartcutsMacros.t_encode(v._0)
            ];
        case /* MultiUrlTriggeringWithCreds */ 4:
            return [
                "MultiUrlTriggeringWithCreds",
                t_encode(v._0)
            ];
    }
}
function status_encode(v) {
    if (typeof v !== "number") {
        return [
            "Failed",
            failedState_encode(v._0)
        ];
    }
    switch(v){
        case /* Created */ 0:
            return [
                "Created"
            ];
        case /* Queued */ 1:
            return [
                "Queued"
            ];
        case /* InProgress */ 2:
            return [
                "InProgress"
            ];
        case /* Cancelled */ 3:
            return [
                "Cancelled"
            ];
        case /* Finished */ 4:
            return [
                "Finished"
            ];
    }
}
function status_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Cancelled":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Cancelled */ 3
                    };
                }
            case "Created":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Created */ 0
                    };
                }
            case "Failed":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = failedState_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Failed */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Finished":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Finished */ 4
                    };
                }
            case "InProgress":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* InProgress */ 2
                    };
                }
            case "Queued":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Queued */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function dataSource_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Form":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Form */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "FormWithCreds":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = PlaybackValues$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FormWithCreds */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "GoogleSheet":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = googleSheet_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GoogleSheet */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "MultiUrlTriggering":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = multiUrlTriggeringTrigger_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.arrayFromJson(PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* MultiUrlTriggering */ 2,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$3 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "MultiUrlTriggeringWithCreds":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MultiUrlTriggeringWithCreds */ 4,
                            _0: v0$3._0
                        }
                    };
                }
                var e$5 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "dataSource",
            dataSource_encode(v.dataSource)
        ],
        [
            "name",
            Decco.optionToJson(Decco.stringToJson, v.name)
        ],
        [
            "installedSmartcutId",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
        ],
        [
            "createdAt",
            Decco.floatToJson(v.createdAt)
        ],
        [
            "playbackOptions",
            Decco.optionToJson(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode, v.playbackOptions)
        ],
        [
            "status",
            status_encode(v.status)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var dataSource = dataSource_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSource"), null));
        if (dataSource.TAG === /* Ok */ 0) {
            var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
            if (name.TAG === /* Ok */ 0) {
                var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
                if (installedSmartcutId.TAG === /* Ok */ 0) {
                    var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
                    if (createdAt.TAG === /* Ok */ 0) {
                        var playbackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackOptions"), null));
                        if (playbackOptions.TAG === /* Ok */ 0) {
                            var status = status_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
                            if (status.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        id: id._0,
                                        dataSource: dataSource._0,
                                        name: name._0,
                                        installedSmartcutId: installedSmartcutId._0,
                                        createdAt: createdAt._0,
                                        playbackOptions: playbackOptions._0,
                                        status: status._0
                                    }
                                };
                            }
                            var e = status._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".status" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = playbackOptions._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".playbackOptions" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = createdAt._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".createdAt" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = installedSmartcutId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".installedSmartcutId" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = name._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".name" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = dataSource._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dataSource" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
function stringifyStatus(status) {
    if (typeof status !== "number") {
        return "Failed(" + status._0 + ")";
    }
    switch(status){
        case /* Created */ 0:
            return "Created";
        case /* Queued */ 1:
            return "Queued";
        case /* InProgress */ 2:
            return "InProgress";
        case /* Cancelled */ 3:
            return "Cancelled";
        case /* Finished */ 4:
            return "Finished";
    }
}
function stringifyMultiUrlTriggeringTrigger(trigger) {
    if (trigger) {
        return "PopupMultiUrlTrigger";
    } else {
        return "ContextMenuMultiUrlTrigger";
    }
}
function getNameOrHumanizedAlias(param) {
    var name = param.name;
    if (name !== undefined) {
        return name;
    }
    switch(param.dataSource.TAG | 0){
        case /* GoogleSheet */ 1:
            return "Google Sheets Execution";
        case /* Form */ 0:
        case /* FormWithCreds */ 3:
            return "Smartcuts Form Execution";
        case /* MultiUrlTriggering */ 2:
        case /* MultiUrlTriggeringWithCreds */ 4:
            return "Multi URL Execution";
    }
}
function make(dataSource, installedSmartcutId, status, userSpecifiedPlaybackOptions, maybeId, maybeName, param) {
    return {
        id: OptionUtils$SmartcutsMacros.withDefault(Uuid.v1(), maybeId),
        dataSource: dataSource,
        name: maybeName,
        installedSmartcutId: installedSmartcutId,
        createdAt: Date.now(),
        playbackOptions: userSpecifiedPlaybackOptions,
        status: status
    };
}
function size(param) {
    var dataSource = param.dataSource;
    switch(dataSource.TAG | 0){
        case /* GoogleSheet */ 1:
            var spreadsheetId = dataSource._0.spreadsheetId;
            return Browser__Identity$SmartcutsMacros.getAuthToken(true, true, undefined, undefined, undefined).then(function(maybeAccessToken) {
                var arg = Belt_Option.map(maybeAccessToken, function(accessToken) {
                    return GoogleSheetHelpers$SmartcutsMacros.loadClientButReloadExtensionIfGapiIsNotDefined(undefined).then(function(client) {
                        return GoogleSheetHelpers$SmartcutsMacros.getSpreadsheetSize_withEdgeCaseHandling(spreadsheetId, accessToken, undefined, client);
                    });
                });
                var _$param = Promise.resolve(-1);
                return OptionUtils$SmartcutsMacros.withDefault(_$param, arg);
            });
        case /* MultiUrlTriggering */ 2:
            return Promise.resolve(dataSource._1.length);
        case /* Form */ 0:
        case /* FormWithCreds */ 3:
            return Promise.resolve(1);
        case /* MultiUrlTriggeringWithCreds */ 4:
            return Promise.resolve(dataSource._0.hrefs.length);
    }
}
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "googleSheet",
            googleSheet_encode(v.googleSheet)
        ],
        [
            "name",
            Decco.optionToJson(Decco.stringToJson, v.name)
        ],
        [
            "installedSmartcutId",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
        ],
        [
            "createdAt",
            Decco.floatToJson(v.createdAt)
        ],
        [
            "playbackOptions",
            Decco.optionToJson(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode, v.playbackOptions)
        ],
        [
            "status",
            status_encode(v.status)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var googleSheet = googleSheet_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "googleSheet"), null));
        if (googleSheet.TAG === /* Ok */ 0) {
            var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
            if (name.TAG === /* Ok */ 0) {
                var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
                if (installedSmartcutId.TAG === /* Ok */ 0) {
                    var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
                    if (createdAt.TAG === /* Ok */ 0) {
                        var playbackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackOptions"), null));
                        if (playbackOptions.TAG === /* Ok */ 0) {
                            var status = status_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
                            if (status.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        id: id._0,
                                        googleSheet: googleSheet._0,
                                        name: name._0,
                                        installedSmartcutId: installedSmartcutId._0,
                                        createdAt: createdAt._0,
                                        playbackOptions: playbackOptions._0,
                                        status: status._0
                                    }
                                };
                            }
                            var e = status._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".status" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = playbackOptions._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".playbackOptions" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = createdAt._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".createdAt" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = installedSmartcutId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".installedSmartcutId" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = name._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".name" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = googleSheet._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".googleSheet" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
function minify(x) {
    return x;
}
function toExecutionSet(param) {
    return {
        id: param.id,
        dataSource: {
            TAG: /* GoogleSheet */ 1,
            _0: param.googleSheet
        },
        name: param.name,
        installedSmartcutId: param.installedSmartcutId,
        createdAt: param.createdAt,
        playbackOptions: param.playbackOptions,
        status: param.status
    };
}
var ForGoogleSheet = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    minify: minify,
    toExecutionSet: toExecutionSet
};
var ExecutionSet = {
    multiUrlTriggeringTrigger_encode: multiUrlTriggeringTrigger_encode,
    multiUrlTriggeringTrigger_decode: multiUrlTriggeringTrigger_decode,
    MultiUrlTriggeringWithCreds: MultiUrlTriggeringWithCreds,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    dataSource_encode: dataSource_encode,
    dataSource_decode: dataSource_decode,
    googleSheet_encode: googleSheet_encode,
    googleSheet_decode: googleSheet_decode,
    status_encode: status_encode,
    status_decode: status_decode,
    failedState_encode: failedState_encode,
    failedState_decode: failedState_decode,
    failedReason_encode: failedReason_encode,
    failedReason_decode: failedReason_decode,
    stringifyStatus: stringifyStatus,
    stringifyMultiUrlTriggeringTrigger: stringifyMultiUrlTriggeringTrigger,
    getNameOrHumanizedAlias: getNameOrHumanizedAlias,
    make: make,
    size: size,
    ForGoogleSheet: ForGoogleSheet
};
function errorDetails_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "SelectorFailure":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SelectorFailure */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "UnknownError":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UnknownError */ 1
                    };
                }
            case "UserStoppedPlayback":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UserStoppedPlayback */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function error_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var failedStepIndex = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedStepIndex"), null));
    if (failedStepIndex.TAG === /* Ok */ 0) {
        var errorDetails = errorDetails_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "errorDetails"), null));
        if (errorDetails.TAG === /* Ok */ 0) {
            var resolved = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resolved"), null));
            if (resolved.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        failedStepIndex: failedStepIndex._0,
                        errorDetails: errorDetails._0,
                        resolved: resolved._0
                    }
                };
            }
            var e = resolved._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".resolved" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = errorDetails._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".errorDetails" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = failedStepIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".failedStepIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function errorDetails_encode(v) {
    if (typeof v === "number") {
        if (v !== 0) {
            return [
                "UnknownError"
            ];
        } else {
            return [
                "UserStoppedPlayback"
            ];
        }
    } else {
        return [
            "SelectorFailure",
            Selector$SmartcutsMacros.selector_encode(v._0)
        ];
    }
}
function error_encode(v) {
    return Js_dict.fromArray([
        [
            "failedStepIndex",
            Decco.optionToJson(Decco.intToJson, v.failedStepIndex)
        ],
        [
            "errorDetails",
            errorDetails_encode(v.errorDetails)
        ],
        [
            "resolved",
            Decco.boolToJson(v.resolved)
        ]
    ]);
}
function status_encode$1(v) {
    if (typeof v === "number") {
        if (v !== 0) {
            return [
                "ExitedWithSuccess"
            ];
        } else {
            return [
                "Running"
            ];
        }
    } else {
        return [
            "ExitedWithError",
            error_encode(v._0)
        ];
    }
}
function status_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ExitedWithError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = error_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExitedWithError */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ExitedWithSuccess":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExitedWithSuccess */ 1
                    };
                }
            case "Running":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Running */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "taskId",
            Decco.stringToJson(v.taskId)
        ],
        [
            "installedSmartcutId",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
        ],
        [
            "createdAt",
            Decco.floatToJson(v.createdAt)
        ],
        [
            "playbackValues",
            PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v.playbackValues)
        ],
        [
            "credentialDbIdsByHostname",
            Decco.optionToJson(function(param) {
                return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(UserCredential$SmartcutsMacros.DbId.id_encode, param);
            }, v.credentialDbIdsByHostname)
        ],
        [
            "status",
            status_encode$1(v.status)
        ],
        [
            "failureId",
            Decco.optionToJson(Decco.stringToJson, v.failureId)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var taskId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "taskId"), null));
        if (taskId.TAG === /* Ok */ 0) {
            var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
            if (installedSmartcutId.TAG === /* Ok */ 0) {
                var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
                if (createdAt.TAG === /* Ok */ 0) {
                    var playbackValues = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackValues"), null));
                    if (playbackValues.TAG === /* Ok */ 0) {
                        var credentialDbIdsByHostname = Decco.optionFromJson(function(param) {
                            return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(UserCredential$SmartcutsMacros.DbId.id_decode, param);
                        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialDbIdsByHostname"), null));
                        if (credentialDbIdsByHostname.TAG === /* Ok */ 0) {
                            var status = status_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
                            if (status.TAG === /* Ok */ 0) {
                                var failureId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureId"), null));
                                if (failureId.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            id: id._0,
                                            taskId: taskId._0,
                                            installedSmartcutId: installedSmartcutId._0,
                                            createdAt: createdAt._0,
                                            playbackValues: playbackValues._0,
                                            credentialDbIdsByHostname: credentialDbIdsByHostname._0,
                                            status: status._0,
                                            failureId: failureId._0
                                        }
                                    };
                                }
                                var e = failureId._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".failureId" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = status._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".status" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = credentialDbIdsByHostname._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".credentialDbIdsByHostname" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = playbackValues._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".playbackValues" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = createdAt._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".createdAt" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = installedSmartcutId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".installedSmartcutId" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = taskId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".taskId" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
function makeWithId(id, executionSetId, installedSmartcutId, playbackValues) {
    return {
        id: id,
        taskId: executionSetId,
        installedSmartcutId: installedSmartcutId,
        createdAt: Date.now(),
        playbackValues: PlaybackValues$SmartcutsMacros.getSmartcutParamValuesByCommandIndex(playbackValues),
        credentialDbIdsByHostname: Caml_option.some(playbackValues.credentialDbIdsByHostname),
        status: /* Running */ 0,
        failureId: undefined
    };
}
function make$1(executionSetId, installedSmartcutId, playbackValues) {
    return {
        id: Uuid.v1(),
        taskId: executionSetId,
        installedSmartcutId: installedSmartcutId,
        createdAt: Date.now(),
        playbackValues: PlaybackValues$SmartcutsMacros.getSmartcutParamValuesByCommandIndex(playbackValues),
        credentialDbIdsByHostname: Caml_option.some(playbackValues.credentialDbIdsByHostname),
        status: /* Running */ 0,
        failureId: undefined
    };
}
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "playbackValues",
            Decco.optionToJson(function(param) {
                return CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(PlaybackParamValue$SmartcutsMacros.Update.t_encode, param);
            }, v.playbackValues)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var playbackValues = Decco.optionFromJson(function(param) {
        return CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(PlaybackParamValue$SmartcutsMacros.Update.t_decode, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict._0, "playbackValues"), null));
    if (playbackValues.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                playbackValues: playbackValues._0
            }
        };
    }
    var e = playbackValues._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".playbackValues" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function stringify(param1) {
    return "{ playbackValues: " + (OptionUtils$SmartcutsMacros.stringify(function(map) {
        return "{" + (Belt_Array.map(Belt_MapInt.toArray(map), function(param) {
            return String(param[0]) + (" -> " + PlaybackParamValue$SmartcutsMacros.Update.stringify(param[1]));
        }).join(", ") + "}");
    }, param1.playbackValues) + " }");
}
function apply(execution, param2) {
    var arg = Belt_Option.map(param2.playbackValues, function(updates) {
        return Belt_Array.reduce(Belt_MapInt.toArray(updates), execution.playbackValues, function(playbackValues, param) {
            var update = param[1];
            return Belt_MapInt.update(playbackValues, param[0], function(maybeValue) {
                return Belt_Option.map(maybeValue, function(value) {
                    var func = PlaybackParamValue$SmartcutsMacros.Update.apply;
                    return Curry._2(func, value, update);
                });
            });
        });
    });
    return {
        id: execution.id,
        taskId: execution.taskId,
        installedSmartcutId: execution.installedSmartcutId,
        createdAt: execution.createdAt,
        playbackValues: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }(execution.playbackValues),
        credentialDbIdsByHostname: execution.credentialDbIdsByHostname,
        status: execution.status,
        failureId: execution.failureId
    };
}
var Update = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify,
    apply: apply
};
var Execution = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    status_encode: status_encode$1,
    status_decode: status_decode$1,
    error_encode: error_encode,
    error_decode: error_decode,
    errorDetails_encode: errorDetails_encode,
    errorDetails_decode: errorDetails_decode,
    makeWithId: makeWithId,
    make: make$1,
    Update: Update
};
exports.ExecutionSet = ExecutionSet;
exports.Execution = Execution; /* uuid Not a pure module */ 


/***/ }),

/***/ 7352:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var _map = {
    "SUPERADMIN": "SUPERADMIN",
    "CUSTOMER": "CUSTOMER",
    "WAITLIST": "WAITLIST",
    "REVIEWER": "REVIEWER"
};
function tToJs(param) {
    return param;
}
function tFromJs(param) {
    return _map[param];
}
var UserRole = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "User.UserRole.t",
    tToJs: tToJs,
    tFromJs: tFromJs
});
var _map$1 = {
    "CANARY": "CANARY"
};
function tToJs$1(param) {
    return param;
}
function tFromJs$1(param) {
    return _map$1[param];
}
var ExtensionBuild = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "User.ExtensionBuild.t",
    tToJs: tToJs$1,
    tFromJs: tFromJs$1
});
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "token",
            Decco.stringToJson(v.token)
        ],
        [
            "userId",
            Decco.stringToJson(v.userId)
        ],
        [
            "email",
            Decco.stringToJson(v.email)
        ],
        [
            "role",
            Curry._1(UserRole.t_encode, v.role)
        ],
        [
            "build",
            Decco.optionToJson(ExtensionBuild.t_encode, v.build)
        ],
        [
            "finishedOnboarding",
            Decco.boolToJson(v.finishedOnboarding)
        ],
        [
            "userFlags",
            Decco.arrayToJson(Decco.stringToJson, v.userFlags)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var token = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "token"), null));
    if (token.TAG === /* Ok */ 0) {
        var userId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "userId"), null));
        if (userId.TAG === /* Ok */ 0) {
            var email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
            if (email.TAG === /* Ok */ 0) {
                var role = Curry._1(UserRole.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "role"), null));
                if (role.TAG === /* Ok */ 0) {
                    var build = Decco.optionFromJson(ExtensionBuild.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "build"), null));
                    if (build.TAG === /* Ok */ 0) {
                        var finishedOnboarding = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "finishedOnboarding"), null));
                        if (finishedOnboarding.TAG === /* Ok */ 0) {
                            var userFlags = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "userFlags"), null));
                            if (userFlags.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        token: token._0,
                                        userId: userId._0,
                                        email: email._0,
                                        role: role._0,
                                        build: build._0,
                                        finishedOnboarding: finishedOnboarding._0,
                                        userFlags: userFlags._0
                                    }
                                };
                            }
                            var e = userFlags._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".userFlags" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = finishedOnboarding._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".finishedOnboarding" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = build._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".build" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = role._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".role" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = email._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".email" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = userId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".userId" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = token._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".token" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
exports.UserRole = UserRole;
exports.ExtensionBuild = ExtensionBuild;
exports.t_encode = t_encode;
exports.t_decode = t_decode; /* UserRole Not a pure module */ 


/***/ }),

/***/ 98207:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var Util$SmartcutsMacros = __webpack_require__(25092);
var IdMaker$SmartcutsMacros = __webpack_require__(83188);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var LoginSmartcut$SmartcutsMacros = __webpack_require__(26553);
var OAuthProvider$SmartcutsMacros = __webpack_require__(86090);
var UserCredential__OAuthCredential$SmartcutsMacros = __webpack_require__(34457);
var UserCredential__PasswordCredential$SmartcutsMacros = __webpack_require__(83292);
function t_encode(encoder_oauthProviderCredential, v) {
    if (v.TAG === /* PasswordCredential */ 0) {
        return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdOrPassword.t_encode(v._0)
        ];
    } else {
        return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_encode(encoder_oauthProviderCredential, v._0)
        ];
    }
}
function t_decode(decoder_oauthProviderCredential, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OAuthCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_decode(decoder_oauthProviderCredential, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OAuthCredential */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "PasswordCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdOrPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCredential */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(stringifyOAuthProviderCredential, credential) {
    if (credential.TAG !== /* PasswordCredential */ 0) {
        return "OAuthCredential(" + (UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.stringify(stringifyOAuthProviderCredential, credential._0) + ")");
    }
    var match = credential._0;
    return "PasswordCredential(hostname=" + (match.hostname + (", username=" + (match.username + ")")));
}
function hostnameGet(v) {
    return v._0.hostname;
}
var GenericWithoutIdOrSecureData = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    hostnameGet: hostnameGet
};
function t_encode$1(encoder_oauthProviderCredential, v) {
    if (v.TAG === /* PasswordCredential */ 0) {
        return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_encode(v._0)
        ];
    } else {
        return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_encode(encoder_oauthProviderCredential, v._0)
        ];
    }
}
function t_decode$1(decoder_oauthProviderCredential, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OAuthCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_decode(decoder_oauthProviderCredential, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OAuthCredential */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "PasswordCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCredential */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(stringifyOAuthProviderCredential, credential) {
    if (credential.TAG !== /* PasswordCredential */ 0) {
        return "OAuthCredential(" + (UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.stringify(stringifyOAuthProviderCredential, credential._0) + ")");
    }
    var match = credential._0;
    return "PasswordCredential(hostname=" + (match.hostname + (", username=" + (match.username + ")")));
}
function hostnameGet$1(v) {
    return v._0.hostname;
}
var GenericWithoutIdWithPassword = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    hostnameGet: hostnameGet$1
};
function t_encode$2(v) {
    return t_encode(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v);
}
function t_decode$2(v) {
    return t_decode(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, v);
}
function stringify$2(param) {
    return stringify(function(param) {
        return "";
    }, param);
}
var WithoutIdOrSecureDataAndWithNestedProviderCredentialRef = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2
};
function t_encode$3(v) {
    if (v.TAG === /* PasswordCredential */ 0) {
        return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_encode(v._0)
        ];
    } else {
        return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_encode(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v._0)
        ];
    }
}
function t_decode$3(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OAuthCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_decode(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OAuthCredential */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "PasswordCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCredential */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$3(v) {
    if (v.TAG === /* PasswordCredential */ 0) {
        return "PasswordCredential(" + (UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.stringify(v._0) + ")");
    }
    var func = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.stringify;
    return "OAuthCredential(" + (Curry._2(func, function(prim) {
        return prim;
    }, v._0) + ")");
}
var WithoutIdWithPasswordAndWithNestedProviderCredentialRef = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringify: stringify$3
};
function t_encode$4(v) {
    if (v.TAG === /* PasswordCredential */ 0) {
        return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_encode(v._0)
        ];
    } else {
        return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_encode(UserCredential__PasswordCredential$SmartcutsMacros.t_encode, v._0)
        ];
    }
}
function t_decode$4(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OAuthCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_decode(UserCredential__PasswordCredential$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OAuthCredential */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "PasswordCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCredential */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function hostnameGet$2(v) {
    return v._0.hostname;
}
function usernameGet(v) {
    if (v.TAG === /* PasswordCredential */ 0) {
        return v._0.username;
    } else {
        return v._0.oauthProviderCredential.username;
    }
}
var WithoutIdWithPasswordAndHydratedOAuthProviderCredential = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    hostnameGet: hostnameGet$2,
    usernameGet: usernameGet
};
function t_encode$5(encoder_oauthProviderCredential, v) {
    if (v.TAG === /* PasswordCredential */ 0) {
        return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.t_encode(v._0)
        ];
    } else {
        return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.t_encode(encoder_oauthProviderCredential, v._0)
        ];
    }
}
function t_decode$5(decoder_oauthProviderCredential, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OAuthCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = UserCredential__OAuthCredential$SmartcutsMacros.t_decode(decoder_oauthProviderCredential, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OAuthCredential */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "PasswordCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCredential */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var Generic = {
    t_encode: t_encode$5,
    t_decode: t_decode$5
};
var include = IdMaker$SmartcutsMacros.Make({
    name: "DbId"
});
var id_encode = include.id_encode;
var id_decode = include.id_decode;
function fromPasswordCredentialId(passwordId) {
    return passwordId;
}
function toPasswordCredentialId(dbId) {
    return dbId;
}
function toOAuthCredentialId(dbId) {
    return dbId;
}
var DbId_doesEqualStringId = include.doesEqualStringId;
var DbId_cmp = include.cmp;
var DbId = {
    id_encode: id_encode,
    id_decode: id_decode,
    doesEqualStringId: DbId_doesEqualStringId,
    cmp: DbId_cmp,
    fromPasswordCredentialId: fromPasswordCredentialId,
    toPasswordCredentialId: toPasswordCredentialId,
    toOAuthCredentialId: toOAuthCredentialId
};
function t_encode$6(v) {
    return t_encode$5(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v);
}
function t_decode$6(v) {
    return t_decode$5(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, v);
}
function stringify$4(credential) {
    if (credential.TAG !== /* PasswordCredential */ 0) {
        return "OAuthCredential(oauthProvider=" + (OAuthProvider$SmartcutsMacros.stringify(credential._0.oauthProvider) + ")");
    }
    var match = credential._0;
    return "PasswordCredential(hostname=" + (match.hostname + (", username=" + (match.username + ")")));
}
function dbIdGet(credential) {
    return credential._0.id;
}
function hostnameGet$3(credential) {
    return credential._0.hostname;
}
function isPasswordCredential(credential) {
    if (credential.TAG === /* PasswordCredential */ 0) {
        return true;
    } else {
        return false;
    }
}
function doesMatchUrl(url, credential) {
    var match = URLUtils$SmartcutsMacros.$$URL.fromString(url);
    if (match !== undefined) {
        return credential._0.hostname === match.origin;
    } else {
        return false;
    }
}
var WithExistingCredentialOrCreatePasswordCredential = {};
var WithoutIdOrSecureDataWithNestedNewOrExistingPasswordCredentialForOAuth = {};
var WithoutIdWithPasswordWithNestedNewOrExistingPasswordCredentialForOAuth = {};
function t_encode$7(v) {
    return Js_dict.fromArray([
        [
            "id",
            Curry._1(id_encode, v.id)
        ],
        [
            "hostname",
            Decco.stringToJson(v.hostname)
        ],
        [
            "credentialSchemaVersion",
            Decco.stringToJson(v.credentialSchemaVersion)
        ],
        [
            "credential",
            t_encode(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v.credential)
        ]
    ]);
}
function t_decode$7(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Curry._1(id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
        if (hostname.TAG === /* Ok */ 0) {
            var credentialSchemaVersion = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialSchemaVersion"), null));
            if (credentialSchemaVersion.TAG === /* Ok */ 0) {
                var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "credential"), null);
                var credential = t_decode(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, v$1);
                if (credential.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            id: id._0,
                            hostname: hostname._0,
                            credentialSchemaVersion: credentialSchemaVersion._0,
                            credential: credential._0
                        }
                    };
                }
                var e = credential._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".credential" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = credentialSchemaVersion._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".credentialSchemaVersion" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = hostname._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".hostname" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function usernameGet$1(param) {
    return param.credential._0.username;
}
var DbRecord = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    usernameGet: usernameGet$1
};
function t_encode$8(v) {
    if (v.TAG === /* PasswordCredential */ 0) {
        return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithIdAndNeedsReEntryStatusWithoutPassword.t_encode(v._0)
        ];
    } else {
        return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.t_encode(UserCredential__PasswordCredential$SmartcutsMacros.WithIdAndNeedsReEntryStatusWithoutPassword.t_encode, v._0)
        ];
    }
}
function t_decode$8(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OAuthCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = UserCredential__OAuthCredential$SmartcutsMacros.t_decode(UserCredential__PasswordCredential$SmartcutsMacros.WithIdAndNeedsReEntryStatusWithoutPassword.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OAuthCredential */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "PasswordCredential":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithIdAndNeedsReEntryStatusWithoutPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCredential */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function makeFromDbIdAndFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef(id, userCredential, credentialsThatNeedPasswordReEntry, credentialsFromDb) {
    if (userCredential.TAG === /* PasswordCredential */ 0) {
        var match = userCredential._0;
        return {
            TAG: /* PasswordCredential */ 0,
            _0: {
                id: id,
                hostname: match.hostname,
                username: match.username,
                reEntryStatus: Belt_Array.some(credentialsThatNeedPasswordReEntry, function(currId) {
                    return Caml_obj.caml_equal(currId, id);
                }) ? /* DoesNeedToBeReentered */ 1 : /* DoesNotNeedToBeReentered */ 2
            }
        };
    }
    var match$1 = userCredential._0;
    var providerPasswordCredentialId = match$1.oauthProviderCredential;
    var arg = Belt_Array.getBy(credentialsFromDb, function(x) {
        return Caml_obj.caml_equal(x.id, providerPasswordCredentialId);
    });
    var matchingProviderPassCredential = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected password credential with id" + providerPasswordCredentialId);
    return {
        TAG: /* OAuthCredential */ 1,
        _0: {
            id: id,
            hostname: match$1.hostname,
            username: match$1.username,
            oauthProvider: match$1.oauthProvider,
            oauthProviderCredential: {
                id: providerPasswordCredentialId,
                hostname: matchingProviderPassCredential.hostname,
                username: usernameGet$1(matchingProviderPassCredential),
                reEntryStatus: Belt_Array.some(credentialsThatNeedPasswordReEntry, function(idOfCred) {
                    return Caml_obj.caml_equal(idOfCred, providerPasswordCredentialId);
                }) ? /* DoesNeedToBeReentered */ 1 : /* DoesNotNeedToBeReentered */ 2
            }
        }
    };
}
function dbIdGet$1(credential) {
    return credential._0.id;
}
function hostnameGet$4(credential) {
    return credential._0.hostname;
}
function isPasswordCredential$1(credential) {
    if (credential.TAG === /* PasswordCredential */ 0) {
        return true;
    } else {
        return false;
    }
}
function doesMatchHostname(hostnameToMatch, credential) {
    return credential._0.hostname === hostnameToMatch;
}
function needsReEntryPassword(credential) {
    if (credential.TAG === /* PasswordCredential */ 0) {
        return credential._0.reEntryStatus === 1;
    } else {
        return credential._0.oauthProviderCredential.reEntryStatus === 1;
    }
}
var WithReEntryStatusAndOAuthProviderCredential = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    makeFromDbIdAndFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef: makeFromDbIdAndFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef,
    dbIdGet: dbIdGet$1,
    hostnameGet: hostnameGet$4,
    isPasswordCredential: isPasswordCredential$1,
    doesMatchHostname: doesMatchHostname,
    needsReEntryPassword: needsReEntryPassword
};
function t__encode(v) {
    return t_encode$5(UserCredential__PasswordCredential$SmartcutsMacros.t_encode, v);
}
function t__decode(v) {
    return t_decode$5(UserCredential__PasswordCredential$SmartcutsMacros.t_decode, v);
}
function fromUnresolved(userCredentials, unresolvedCredential) {
    if (unresolvedCredential.TAG === /* PasswordCredential */ 0) {
        return {
            TAG: /* PasswordCredential */ 0,
            _0: unresolvedCredential._0
        };
    }
    var match = unresolvedCredential._0;
    var passwordCredentialId = match.oauthProviderCredential;
    var oauthProviderCredential1 = ArrayUtils$SmartcutsMacros.shortcut(function(credential) {
        if (credential.TAG !== /* PasswordCredential */ 0) {
            return;
        }
        var oauthProviderCredential = credential._0;
        if (Caml_obj.caml_equal(oauthProviderCredential.id, passwordCredentialId)) {
            return oauthProviderCredential;
        }
    }, userCredentials);
    if (oauthProviderCredential1 !== undefined) {
        return {
            TAG: /* OAuthCredential */ 1,
            _0: {
                id: match.id,
                hostname: match.hostname,
                username: oauthProviderCredential1.username,
                oauthProvider: match.oauthProvider,
                oauthProviderCredential: {
                    id: oauthProviderCredential1.id,
                    hostname: oauthProviderCredential1.hostname,
                    username: oauthProviderCredential1.username
                }
            }
        };
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Could not resolve oauthProviderCredential with id = " + passwordCredentialId + " ");
    }
}
function getIdOfUnderlyingPasswordCredential(credential) {
    if (credential.TAG === /* PasswordCredential */ 0) {
        return credential._0.id;
    } else {
        return credential._0.oauthProviderCredential.id;
    }
}
var WithOAuthProviderCredential = {
    t__encode: t__encode,
    t__decode: t__decode,
    fromUnresolved: fromUnresolved,
    getIdOfUnderlyingPasswordCredential: getIdOfUnderlyingPasswordCredential
};
function t_encode$9(v) {
    if (v.TAG === /* PasswordCredentialRef */ 0) {
        return [
            "PasswordCredentialRef",
            Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v._0)
        ];
    } else {
        return [
            "OAuthCredentialRef",
            Curry._1(UserCredential__OAuthCredential$SmartcutsMacros.id_encode, v._0)
        ];
    }
}
function t_decode$9(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OAuthCredentialRef":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(UserCredential__OAuthCredential$SmartcutsMacros.id_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OAuthCredentialRef */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "PasswordCredentialRef":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCredentialRef */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function make(credential) {
    if (credential.TAG === /* PasswordCredential */ 0) {
        return {
            TAG: /* PasswordCredentialRef */ 0,
            _0: credential._0.id
        };
    } else {
        return {
            TAG: /* OAuthCredentialRef */ 1,
            _0: credential._0.id
        };
    }
}
function stringify$5(credentialRef) {
    if (credentialRef.TAG === /* PasswordCredentialRef */ 0) {
        return "PasswordCredentialRef(" + credentialRef._0 + ")";
    } else {
        return "OAuthCredentialRef(" + credentialRef._0 + ")";
    }
}
function fromUserCredential(userCredential) {
    if (userCredential.TAG === /* PasswordCredential */ 0) {
        return {
            TAG: /* PasswordCredentialRef */ 0,
            _0: userCredential._0.id
        };
    } else {
        return {
            TAG: /* OAuthCredentialRef */ 1,
            _0: userCredential._0.id
        };
    }
}
var CredentialRef = {
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    make: make,
    stringify: stringify$5,
    fromUserCredential: fromUserCredential
};
function doesMatchCredentialRef(credentialRef, credential) {
    if (credential.TAG === /* PasswordCredential */ 0) {
        if (credentialRef.TAG === /* PasswordCredentialRef */ 0) {
            return Caml_obj.caml_equal(credential._0.id, credentialRef._0);
        } else {
            return false;
        }
    } else if (credentialRef.TAG === /* PasswordCredentialRef */ 0) {
        return false;
    } else {
        return Caml_obj.caml_equal(credential._0.id, credentialRef._0);
    }
}
function toWithoutIdOrSecureDataAndWithNestedProviderCredentialRef(userCredential) {
    if (userCredential.TAG === /* PasswordCredential */ 0) {
        var match = userCredential._0;
        return {
            TAG: /* PasswordCredential */ 0,
            _0: {
                hostname: match.hostname,
                username: match.username
            }
        };
    }
    var match$1 = userCredential._0;
    return {
        TAG: /* OAuthCredential */ 1,
        _0: {
            hostname: match$1.hostname,
            username: match$1.username,
            oauthProvider: match$1.oauthProvider,
            oauthProviderCredential: match$1.oauthProviderCredential
        }
    };
}
function makeFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef(id, userCredential) {
    if (userCredential.TAG === /* PasswordCredential */ 0) {
        var match = userCredential._0;
        return {
            TAG: /* PasswordCredential */ 0,
            _0: {
                id: id,
                hostname: match.hostname,
                username: match.username
            }
        };
    }
    var match$1 = userCredential._0;
    return {
        TAG: /* OAuthCredential */ 1,
        _0: {
            id: id,
            hostname: match$1.hostname,
            username: match$1.username,
            oauthProvider: match$1.oauthProvider,
            oauthProviderCredential: match$1.oauthProviderCredential
        }
    };
}
function buildDefaultCredentialDbIdsByHostname(loginSmartcuts, userCredentials) {
    return Belt_Array.reduce(Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.getHostnames, loginSmartcuts), undefined, function(credentialDbIdsByHostname, hostname) {
        var maybeDbId = Belt_Array.get(Belt_Array.keepMap(userCredentials, function(credential) {
            if (doesMatchHostname(hostname, credential) && !needsReEntryPassword(credential)) {
                return Caml_option.some(dbIdGet$1(credential));
            }
        }), 0);
        if (maybeDbId !== undefined) {
            return Belt_MapString.set(credentialDbIdsByHostname, hostname, Caml_option.valFromOption(maybeDbId));
        } else {
            return credentialDbIdsByHostname;
        }
    });
}
function areCredentialDbIdsByHostnameIdentical(credentialDbIdsByHostname_A, credentialDbIdsByHostname_B) {
    if (Belt_MapString.size(credentialDbIdsByHostname_A) === Belt_MapString.size(credentialDbIdsByHostname_B)) {
        return Belt_MapString.every(credentialDbIdsByHostname_A, function(hostname, dbId) {
            var arg = Belt_Option.map(Belt_MapString.get(credentialDbIdsByHostname_B, hostname), function(dbId$p) {
                return Caml_obj.caml_equal(dbId, dbId$p);
            });
            var param = false;
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        });
    } else {
        return false;
    }
}
var schemaVersion = "0.0.1";
var PasswordCredential;
var OAuthCredential;
exports.schemaVersion = schemaVersion;
exports.PasswordCredential = PasswordCredential;
exports.OAuthCredential = OAuthCredential;
exports.GenericWithoutIdOrSecureData = GenericWithoutIdOrSecureData;
exports.GenericWithoutIdWithPassword = GenericWithoutIdWithPassword;
exports.WithoutIdOrSecureDataAndWithNestedProviderCredentialRef = WithoutIdOrSecureDataAndWithNestedProviderCredentialRef;
exports.WithoutIdWithPasswordAndWithNestedProviderCredentialRef = WithoutIdWithPasswordAndWithNestedProviderCredentialRef;
exports.WithoutIdWithPasswordAndHydratedOAuthProviderCredential = WithoutIdWithPasswordAndHydratedOAuthProviderCredential;
exports.Generic = Generic;
exports.DbId = DbId;
exports.t_encode = t_encode$6;
exports.t_decode = t_decode$6;
exports.stringify = stringify$4;
exports.dbIdGet = dbIdGet;
exports.hostnameGet = hostnameGet$3;
exports.isPasswordCredential = isPasswordCredential;
exports.doesMatchUrl = doesMatchUrl;
exports.WithExistingCredentialOrCreatePasswordCredential = WithExistingCredentialOrCreatePasswordCredential;
exports.WithoutIdOrSecureDataWithNestedNewOrExistingPasswordCredentialForOAuth = WithoutIdOrSecureDataWithNestedNewOrExistingPasswordCredentialForOAuth;
exports.WithoutIdWithPasswordWithNestedNewOrExistingPasswordCredentialForOAuth = WithoutIdWithPasswordWithNestedNewOrExistingPasswordCredentialForOAuth;
exports.DbRecord = DbRecord;
exports.WithReEntryStatusAndOAuthProviderCredential = WithReEntryStatusAndOAuthProviderCredential;
exports.WithOAuthProviderCredential = WithOAuthProviderCredential;
exports.CredentialRef = CredentialRef;
exports.doesMatchCredentialRef = doesMatchCredentialRef;
exports.toWithoutIdOrSecureDataAndWithNestedProviderCredentialRef = toWithoutIdOrSecureDataAndWithNestedProviderCredentialRef;
exports.makeFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef = makeFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef;
exports.buildDefaultCredentialDbIdsByHostname = buildDefaultCredentialDbIdsByHostname;
exports.areCredentialDbIdsByHostnameIdentical = areCredentialDbIdsByHostnameIdentical; /* include Not a pure module */ 


/***/ }),

/***/ 34457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var IdMaker$SmartcutsMacros = __webpack_require__(83188);
var OAuthProvider$SmartcutsMacros = __webpack_require__(86090);
var include = IdMaker$SmartcutsMacros.Make({
    name: "OAuthCredentialId"
});
var id_encode = include.id_encode;
var id_decode = include.id_decode;
function t_encode(encoder_oauthProviderCredential, v) {
    return Js_dict.fromArray([
        [
            "hostname",
            Decco.stringToJson(v.hostname)
        ],
        [
            "username",
            Decco.stringToJson(v.username)
        ],
        [
            "oauthProvider",
            OAuthProvider$SmartcutsMacros.t_encode(v.oauthProvider)
        ],
        [
            "oauthProviderCredential",
            Curry._1(encoder_oauthProviderCredential, v.oauthProviderCredential)
        ]
    ]);
}
function t_decode(decoder_oauthProviderCredential, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
    if (hostname.TAG === /* Ok */ 0) {
        var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
        if (username.TAG === /* Ok */ 0) {
            var oauthProvider = OAuthProvider$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProvider"), null));
            if (oauthProvider.TAG === /* Ok */ 0) {
                var oauthProviderCredential = Curry._1(decoder_oauthProviderCredential, Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProviderCredential"), null));
                if (oauthProviderCredential.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            hostname: hostname._0,
                            username: username._0,
                            oauthProvider: oauthProvider._0,
                            oauthProviderCredential: oauthProviderCredential._0
                        }
                    };
                }
                var e = oauthProviderCredential._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".oauthProviderCredential" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = oauthProvider._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".oauthProvider" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = username._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".username" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = hostname._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".hostname" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify(stringifyOAuthProviderCredential, param) {
    return "{hostname: " + (param.hostname + (", oauthProvider: " + (OAuthProvider$SmartcutsMacros.stringify(param.oauthProvider) + (", oauthProviderCredential: " + (Curry._1(stringifyOAuthProviderCredential, param.oauthProviderCredential) + "}")))));
}
var WithoutId = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(encoder_oauthProviderCredential, v) {
    return Js_dict.fromArray([
        [
            "id",
            Curry._1(id_encode, v.id)
        ],
        [
            "hostname",
            Decco.stringToJson(v.hostname)
        ],
        [
            "username",
            Decco.stringToJson(v.username)
        ],
        [
            "oauthProvider",
            OAuthProvider$SmartcutsMacros.t_encode(v.oauthProvider)
        ],
        [
            "oauthProviderCredential",
            Curry._1(encoder_oauthProviderCredential, v.oauthProviderCredential)
        ]
    ]);
}
function t_decode$1(decoder_oauthProviderCredential, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Curry._1(id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
        if (hostname.TAG === /* Ok */ 0) {
            var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
            if (username.TAG === /* Ok */ 0) {
                var oauthProvider = OAuthProvider$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProvider"), null));
                if (oauthProvider.TAG === /* Ok */ 0) {
                    var oauthProviderCredential = Curry._1(decoder_oauthProviderCredential, Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProviderCredential"), null));
                    if (oauthProviderCredential.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                id: id._0,
                                hostname: hostname._0,
                                username: username._0,
                                oauthProvider: oauthProvider._0,
                                oauthProviderCredential: oauthProviderCredential._0
                            }
                        };
                    }
                    var e = oauthProviderCredential._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".oauthProviderCredential" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = oauthProvider._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".oauthProvider" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = username._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".username" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = hostname._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".hostname" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
var doesEqualStringId = include.doesEqualStringId;
var cmp = include.cmp;
exports.id_encode = id_encode;
exports.id_decode = id_decode;
exports.doesEqualStringId = doesEqualStringId;
exports.cmp = cmp;
exports.WithoutId = WithoutId;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1; /* include Not a pure module */ 


/***/ })

}]);